import { dynamicGridHeight } from "../../utils/devextreme_utils";

/**
 * @returns {import("../datagrid").Plugin}
 */
export function dynamicHeightPlugin() {
  return {
    id: "dynamicHeight",
    onDataGridCreated() {
      dynamicGridHeight(this);
    },
  };
}
